import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-f-company-info-isp',
    templateUrl: './f-company-info-isp.component.html',
    styleUrls: ['./f-company-info-isp.component.scss'],
    standalone: false
})
export class FCompanyInfoISPComponent {
     isLoading = true;     
     constructor(public generalService:GeneralService, public enrollmentService:EnrollmentService){     
     }

     wizardObj: IWizard = {
          steps: [
                  {step:1, text:'Welcome'} as WizardSteps,
                  {step:2, text:'Company Information'} as WizardSteps,
                  {step:3, text:'User Accounts'} as WizardSteps,
                  {step:4, text:'Review'} as WizardSteps,
                  {step:5, text:'Contract Documents'} as WizardSteps,
                  {step:6, text:'Submit'} as WizardSteps,
                  {step:7, text:'Billing Information'} as WizardSteps
                  ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit() {
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = false;
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngAfterViewInit(){
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

}
